import "@/App.css";
import { ThemeProvider } from "@/context/ThemeContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Analytics } from "@/components/Analytics";

// Shared site chrome for the newer routes (Services, Service Detail, About,
// Contact) — mirrors the ThemeProvider + Navbar/Footer/Analytics setup
// established on the Home/Enterprise/Healthcare pages.
export const PageLayout = ({ children }) => {
    return (
        <ThemeProvider>
            <div className="min-h-screen bg-brand-bg font-body text-brand-text antialiased">
                <Navbar />
                <main>{children}</main>
                <Footer />
                <Analytics />
            </div>
        </ThemeProvider>
    );
};
